// removed by extract-text-webpack-plugin
module.exports = {"margin":"margin___2u4uE","expressionContainer":"expressionContainer___3zfIW","description":"description___2eHr6","expression":"expression___1wFdE","input":"input___3Y-Oz","option":"option___1b4cl"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/EditVariable/MathEditor/styles.scss
// module id = 441
// module chunks = 0